import * as angular from "angular";
import {IController} from "angular";

export class LogisticsVehicleLinkCtrl implements IController {
  id: string;
  name: string;
  showTooltip: boolean;

  $onInit() {
  }

  $onChanges(changes: angular.IOnChangesObject) {

  }
}

angular
  .module('bringoz.admin.logistics-vehicle')
  .component('logisticsVehicleLink', {
    bindings: {
      id: '<',
      name: '<',
      showTooltip: '<'
    },
    template: require('./logistics-vehicle-link.html').default,
    controller: LogisticsVehicleLinkCtrl
  });
